import { render, staticRenderFns } from "./videoMenu.vue?vue&type=template&id=8a19e772&scoped=true"
import script from "./videoMenu.vue?vue&type=script&lang=js"
export * from "./videoMenu.vue?vue&type=script&lang=js"
import style0 from "./videoMenu.vue?vue&type=style&index=0&id=8a19e772&prod&lang=less&scoped=true"
import style1 from "./videoMenu.vue?vue&type=style&index=1&id=8a19e772&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a19e772",
  null
  
)

export default component.exports